module.exports = __webpack_public_path__ + "images/category_lp/common/icon-sagaku_55652ffe66286cf22ab20615cc49600f.svg";